module.exports = __webpack_public_path__ + "static/media/style1.08be058e.svg";